
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { UserRepoInterface, UserInterface, UsersTableInterface } from '@/services/Users/Interfaces';
import DeleteUserDialog from '@/components/dialogs/users/DeleteUserDialog.vue';
import { DataTableHeader } from 'vuetify';
import ChangeUsersRoleDialog from '@/components/dialogs/users/ChangeUsersRoleDialog.vue';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    DeleteUserDialog,
    ChangeUsersRoleDialog,
  },
  inject: [
    'userRepository',
    'profileRepository',
  ],
})
export default class UserIndex extends Vue {
  private loading: boolean = true;
  private search: string = '';
  private users: UsersTableInterface[] = [];
  private currentPage: number = 1;
  private itemsPerPage: number = 10;
  private totalItems: number = 0;

  private headers: DataTableHeader[] = [
    { text: 'Username', value: 'username' },
    { text: 'Email', value: 'email' },
    { text: 'Name', value: 'name' },
    { text: 'Department', value: 'department' },
    { text: 'Role', value: 'role' },
    { text: 'Deleted', value: 'deletedAt' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private deleteUserForDialog: UserInterface | false = false;
  private deleteUserDialog: string = '';

  private selectedUsers: UserInterface[] | false = [];
  private changeUsersRoleDialog: string = '';

  private readonly userRepository!: UserRepoInterface;
  private readonly profileRepository!: ProfileRepositoryInterface;

  private created(): void {
    this.initialize();
  }

  private async initialize(): Promise<void> {
    this.loading = true;
    this.users = [];
    const [users, count] = await this.userRepository.getAllUsers(this.currentPage, this.search);
    this.users = users as UsersTableInterface[];
    this.totalItems = count;

    const profiles = await this.profileRepository.getBaseProfileDataByUsersIds(users.map((user) => String(user.id)));
    profiles.forEach((profile) => {
      const userIndex = this.users.findIndex((user) => String(user.id) === String(profile.userId));
      if (userIndex !== -1) {
        this.users[userIndex].name = `${profile.firstName} ${profile.lastName}`;
      }
    });

    this.users.map((user: UserInterface) => {
      user.deletedAt = user.deletedAt ? user.deletedAt : 'false';
      return user;
    });

    this.loading = false;
  }

  private createUser(): void {
    this.$router.push({ name: 'user_create' });
  }

  private editUser(user: UserInterface): void {
    this.$router.push({ name: 'user_edit', params: { userId: user.id } });
  }

  private deleteUser(user: UserInterface): void {
    this.deleteUserDialog = 'delete-user-dialog';
    this.deleteUserForDialog = user;
  }

  private async forceLogoutUser(user: UserInterface): Promise<void> {
    await this.userRepository.forceLogout(user.id);
  }

  private async changeRoleOfSelected(): Promise<void> {
    this.changeUsersRoleDialog = 'change-users-role-dialog';
  }

  private async changePage(): Promise<void> {
    this.loading = true;
    await this.initialize();
  }
}
